import { Dispatch } from 'redux';
import {
  ACTION_PUT_EXPENSE_EXPORT_MODEL,
  ACTION_PUT_EXPENSE_EXPORT_MODEL_SUCCESS,
  ACTION_PUT_EXPENSE_EXPORT_MODEL_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { enqueueSnackbarCustomMessageHandler } from '../Status';

export function updateExpenseExportModel(
  model: any,
  onSuccess?: () => void,
  onError?: () => void,
) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/expense-export/${model.id}`,
        method: 'put',
        data: JSON.stringify(model),
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarCustomMessageHandler(
              dispatch,
              'Error: ' + (response.payload?.message || 'Failed to update expense export'),
              'error',
            );
            dispatch(requestFailed(response));
            onError?.();
          } else {
            enqueueSnackbarCustomMessageHandler(
              dispatch,
              'Expense export updated successfully.',
              'success',
            );
            dispatch(requestSuccess(response));
            onSuccess?.();
          }
        },
        fail: (error: any) => {
          enqueueSnackbarCustomMessageHandler(
            dispatch,
            'Error: ' + (error.payload || 'Failed to update expense export'),
            'error',
          );
          dispatch(requestFailed(error));
          onError?.();
        },
      },
    });
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_EXPENSE_EXPORT_MODEL,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_EXPENSE_EXPORT_MODEL_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_EXPENSE_EXPORT_MODEL_FAILURE,
    payload: responseJSON,
  };
}
